import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2TemplatesListResponse {
  list: Array<TemplateData>;
  total: number;
  page: number;
  page_size: number;
};

export interface TemplateData {
  id: number;
  uuid: string;
  template_name: string;
  user_id: number;
  agent_id: number;
  style_model_id: string;
  actor_model_id: string;
  voice_model_id: string;
  cover_url?: string;
  type: number;
  created_at: number;
  updated_at: number;
  deleted_at: number;
};

// 请求接口
interface AgentV2TemplatesListRequest {
  agentId: string,
  userId: string,
  type: number;
  page: number,
  pageSize: number
}

export class AgentTemplatesData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Uuid cannot be empty")
  @IsString("Uuid must be a string")
  uuid: string;

  @Required("Template name cannot be empty")
  @IsString("Template name must be a string")
  templateName: string;

  @Required("Cover url cannot be empty")
  @IsString("Cover url must be a string")
  coverUrl?: string;

  @Required("Cover video cannot be empty")
  @IsString("Cover video must be a string")
  coverVideo?: string;

  @Required("Style model id cannot be empty")
  @IsString("Style model id must be a string")
  styleModelId?: string;

  @Required("Actor model id cannot be empty")
  @IsString("Actor model id must be a string")
  actorModelId?: string;

  @Required("Voice model id cannot be empty")
  @IsString("Voice model id must be a string")
  voiceModelId?: string;

  @IsNumber("Template resource must be a number")
  templateResource?: number;
}

export class AgentV2TemplatesListData {
  @IsArray("List must be an array")
  list: AgentTemplatesData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAgent = (
  response: AgentV2TemplatesListResponse
): AgentV2TemplatesListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2TemplatesListData);
  } catch (error) {
    console.error("Agent V2 Templates data validation failed:", error.message);
    throw error;
  }
};

/** 智能体模板列表 */
export const agentV2TemplatesList = async ({
  page,
  pageSize,
  agentId,
  userId,
  type,
}: AgentV2TemplatesListRequest): Promise<AgentV2TemplatesListData> => {
  const response = await api.post<AgentV2TemplatesListResponse>('/agent-v2/template-list', {
    page,
    page_size: pageSize,
    agent_id: agentId,
    user_id: userId,
    type,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
